import React, { useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { FiRefreshCcw } from "react-icons/fi";

export default function HRCostCard() {
  const [tooltip, setTooltip] = useState(null);

  const data = [
    { label: "Salaries", value: 70, color: "#0f4c5c" },
    { label: "Benefits", value: 20, color: "#5d8e99" },
    { label: "Bonuses", value: 15, color: "#6f9aa3" },
    { label: "Overtime", value: 10, color: "#7faab3" },
    { label: "Training", value: 8, color: "#9fbcc3" },
    { label: "Incentives", value: 7, color: "#c9dde1" },
  ];

  const radius = 95;
  const strokeWidth = 30;

  const totalAngle = 180;
  const gap = 8;
  const segmentAngle =
    (totalAngle - gap * (data.length - 1)) / data.length;

  let currentAngle = -180;

  const polarToCartesian = (cx, cy, r, angle) => {
    const rad = (angle * Math.PI) / 180;
    return {
      x: cx + r * Math.cos(rad),
      y: cy + r * Math.sin(rad),
    };
  };

  const describeArc = (cx, cy, r, startAngle, endAngle) => {
    const start = polarToCartesian(cx, cy, r, endAngle);
    const end = polarToCartesian(cx, cy, r, startAngle);

    return `M ${start.x} ${start.y}
            A ${r} ${r} 0 0 0 ${end.x} ${end.y}`;
  };

  return (
    <Card style={{ borderRadius: 5, border: "2px solid #e5e7eb" }}>
      <Card.Body>
        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 style={{ textDecoration: "underline", fontWeight: 600 }}>
            HR Cost Breakdown
          </h5>

          <div
            style={{
              width: 38,
              height: 38,
              borderRadius: "50%",
              background: "#f3f4f6",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FiRefreshCcw />
          </div>
        </div>

        {/* GRAPH */}
        <div style={{ position: "relative", height: 230 }}>
          <svg viewBox="0 0 260 160" width="100%" height="100%">
            {data.map((item, i) => {
              const start = currentAngle;
              const end = currentAngle + segmentAngle;

              const path = describeArc(130, 130, radius, start, end);

              currentAngle += segmentAngle + gap;

              return (
                <path
                  key={i}
                  d={path}
                  stroke={item.color}
                  strokeWidth={strokeWidth}
                  fill="none"
                  strokeLinecap="round"
                  style={{ cursor: "pointer" }}
                  onMouseEnter={(e) => {
                    const rect = e.target.getBoundingClientRect();
                    setTooltip({
                      ...item,
                      x: rect.x + rect.width / 2,
                      y: rect.y,
                    });
                  }}
                  onMouseLeave={() => setTooltip(null)}
                  onTouchStart={(e) => {
                    const rect = e.target.getBoundingClientRect();
                    setTooltip({
                      ...item,
                      x: rect.x + rect.width / 2,
                      y: rect.y,
                    });
                  }}
                />
              );
            })}
          </svg>

          {/* CENTER VALUE */}
          <div
            style={{
              position: "absolute",
              top: "62%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              fontWeight: 600,
              fontSize: 16,
            }}
          >
            $2,458,900
          </div>

          {/* 🔥 TOOLTIP (EXACT DESIGN) */}
          {tooltip && (
            <div
              style={{
                position: "fixed",
                top: tooltip.y - 70,
                left: tooltip.x - 60,
                background: "#2f2f2f",
                color: "#fff",
                padding: "10px 12px",
                borderRadius: 8,
                fontSize: 13,
                minWidth: 120,
                zIndex: 999,
                boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
              }}
            >
              <div style={{ fontWeight: 600, marginBottom: 5 }}>
                {tooltip.label}
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <div
                  style={{
                    width: 12,
                    height: 12,
                    border: "2px solid #fff",
                    background: tooltip.color,
                  }}
                />
                Semi Donut: {tooltip.value}
              </div>
            </div>
          )}
        </div>

        {/* DETAILS */}
        <Row className="g-3 mt-2">
          {data.map((item, i) => (
            <Col xs={6} sm={4} key={i}>
              <div
                style={{
                  borderLeft: "2px solid #cbd5e1",
                  paddingLeft: 10,
                }}
              >
                <p
                  style={{
                    marginBottom: 4,
                    fontSize: 13,
                    color: "#6b7280",
                  }}
                >
                  {item.label}
                </p>
                <h6 style={{ marginBottom: 0, fontWeight: 600 }}>
                  {item.value}K
                </h6>
              </div>
            </Col>
          ))}
        </Row>
      </Card.Body>
    </Card>
  );
}